// :cow: Cosmose CONFIDENTIAL :iso:
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { APP_CONFIG } from '@med/app/core/config/config.injection-token';
import { environment } from '@med/environments/environment';
import { getConfig } from '@med/app/core/config/get-config';


const config = getConfig(document.location.host);
Object.freeze(config);
if (environment.production) {
  enableProdMode();
}

if (config.smartLookIntegration) {
  enableSmartLookIntegration();
}

platformBrowserDynamic([{provide: APP_CONFIG, useValue: config}])
  .bootstrapModule(AppModule, {applicationProviders: [provideZoneChangeDetection()]})
  .catch(err => console.error(err));

function enableSmartLookIntegration(): void {
  const scriptElement = document.createElement('script');
  scriptElement.type = 'text/javascript';
  scriptElement.innerHTML =
    'window.smartlook||(function(d) {\n' +
    '      var o=smartlook=function(){ o.api.push(arguments)},h=d.getElementsByTagName(\'head\')[0];\n' +
    '      var c=d.createElement(\'script\');o.api=new Array();c.async=true;c.type=\'text/javascript\';\n' +
    '      c.charset=\'utf-8\';c.src=\'https://rec.smartlook.com/recorder.js\';h.appendChild(c);\n' +
    '    })(document);\n' +
    '    smartlook(\'init\', \'a0da1e6f610a2c999626b586cbe85c51a6496ebb\');\n';
  document.getElementsByTagName('head')[0].appendChild(scriptElement);
}
